var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-middle"},[_c('div',{staticClass:"container header-middle-cont"},[_c('div',{staticClass:"toplogo"},[_c('a',{attrs:{"href":"index.html"}},[_c('img',{attrs:{"src":"src/assets/img/logo.png","alt":"LN Repuestos"}})])])])])
}]

export { render, staticRenderFns }